module.exports = __webpack_public_path__ + "img/i-bizRAKYAT.f4c6716e.png";